
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Corporatetravelsinpune() {



    const cardData =
    {
        keyword: 'Corporate Travels in Pune',
        heading: 'Amruta Travels: Corporate Travels in Pune',
        headingDescription: 'Amruta Travels offers Corporate Travels in Pune, delivering professional and efficient transportation solutions tailored for businesses. Whether you are organizing corporate events, employee commutes, client meetings, or team outings, our well-maintained fleet ensures a seamless travel experience. Choose from a variety of buses, including 17-seater, 32-seater, and 50-seater options, to accommodate your team"s size and requirements. With experienced drivers, punctual service, competitive pricing, and 24/7 availability, Amruta Travels makes corporate travel in and around Pune straightforward and stress-free. Partner with us for your corporate transportation needs and experience reliability and comfort every step of the way!',


        top: 'Top Places to Visit in Pune with Amruta Travels',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



   "services": [
    {
      "name": "Travel Agents For Corporate in Pune",
      "description": "Amruta Travels is a trusted travel agency in Pune offering specialized services for corporate clients. From employee transport to outstation corporate tours, we ensure professional service with top-quality buses and tempo travellers."
    },
    {
      "name": "Corporate Travel Company in Pune",
      "description": "As a leading corporate travel company in Pune, Amruta Travels offers reliable and punctual transport solutions for corporate events, office outings, and business tours with a fleet of modern and well-maintained vehicles."
    },
    {
      "name": "Corporate Travel Company in Pimpri Chinchwad",
      "description": "Amruta Travels serves corporate clients in Pimpri Chinchwad with tailored travel solutions including corporate bus rentals, staff transportation, and event logistics using luxury buses and tempo travellers."
    },
    {
      "name": "Bus On Rent For Corporate in Katraj",
      "description": "Looking for corporate bus rental in Katraj? Amruta Travels offers premium buses for team outings, conferences, and business travel with on-time service and experienced drivers."
    },
    {
      "name": "Bus Hire for Corporate Party in Pune",
      "description": "Make your corporate celebration seamless with Amruta Travels’ bus hire service in Pune. Our luxury buses ensure comfortable travel for office parties, retreats, and team events."
    },
    {
      "name": "Bus Hire for Corporate Team Outing in Pune",
      "description": "Plan your next corporate team outing with Amruta Travels. We provide spacious buses with AC, push-back seats, and experienced drivers to ensure a comfortable and fun experience."
    },
    {
      "name": "Bus Hire for Corporate Team Picnic in Pune",
      "description": "Organizing a corporate picnic? Amruta Travels offers buses for group travel with safety, comfort, and reliability at the forefront of our service. Ideal for short and long-distance outings."
    },
    {
      "name": "Pune to Mahabaleshwar Bus Hire for Office Team Picnic",
      "description": "Amruta Travels provides convenient bus hire from Pune to Mahabaleshwar for office team picnics. Enjoy the hill station getaway with smooth transport, flexible timings, and courteous drivers."
    },
    {
      "name": "Bus On Rent For Corporate in Hadapsar",
      "description": "Get buses on rent in Hadapsar for your corporate needs. Amruta Travels offers modern AC and non-AC buses for employee transport, meetings, and company tours."
    },
    {
      "name": "Bus on Rent for Corporate in Hinjewadi",
      "description": "Amruta Travels offers reliable bus rentals for corporate clients in Hinjewadi IT Park. Our services include event transport, group travel, and employee pickup-drop with professional service."
    },
    {
      "name": "Bus on Rent for Corporate in Kharadi",
      "description": "Hire buses for corporate requirements in Kharadi, Pune with Amruta Travels. We offer end-to-end transport solutions for office tours, events, and daily commutes."
    },
    {
      "name": "Bus on Rent for Corporate in IT Park Pune",
      "description": "Amruta Travels caters to various IT Parks in Pune offering bus rentals for corporate travel, offsites, and event logistics. We provide luxury and semi-luxury buses with trained drivers for a professional experience."
    }
  ],
  "tableData": [
    ["Travel Agents For Corporate in Pune", "Corporate Travel Company in Pune"],
    ["Corporate Travel Company in Pimpri Chinchwad", "Bus On Rent For Corporate in Katraj"],
    ["Bus Hire for Corporate Party in Pune", "Bus Hire for Corporate Team Outing in Pune"],
    ["Bus Hire for Corporate Team Picnic in Pune", "Pune to Mahabaleshwar Bus Hire for Office Team Picnic"],
    ["Bus On Rent For Corporate in Hadapsar", "Bus on Rent for Corporate in Hinjewadi"],
    ["Bus on Rent for Corporate in Kharadi", "Bus on Rent for Corporate in IT Park Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Corporate Travel Services in Pune",
    "WhyChoosedescription": "Amruta Travels offers dependable Corporate Travel services in Pune, providing hassle-free transportation for employee commutes, corporate events, conferences, and team-building trips. We understand the importance of punctuality, professionalism, and comfort for your business needs."
  },
  {
    "WhyChooseheading": "Wide Range of Buses for Corporate Groups",
    "WhyChoosedescription": "Whether you're transporting a small team or large groups, we offer a variety of buses, including 17, 20, 32, 35, 40, 45, and 50-seaters. Our fleet is well-maintained, with comfortable seating, air-conditioning (or non-AC on request), and ample space for luggage, ensuring that your employees or clients travel in comfort."
  },
  {
    "WhyChooseheading": "Ideal for Employee Shuttles, Business Events, and Conferences",
    "WhyChoosedescription": "Our Corporate Travel services are perfect for daily office shuttles, employee transport to and from work sites, business meetings, conferences, and corporate retreats. We tailor our services to meet your company’s specific needs, ensuring reliable, timely, and efficient transport solutions."
  },
  {
    "WhyChooseheading": "Punctual and Professional Drivers",
    "WhyChoosedescription": "Our drivers are professional, courteous, and punctual, ensuring that your corporate travel experience is smooth and stress-free. With expert knowledge of Pune’s routes and efficient time management, we make sure your employees or clients reach their destination on time, every time."
  },
  {
    "WhyChooseheading": "Affordable Corporate Travel Solutions with Transparent Pricing",
    "WhyChoosedescription": "Amruta Travels offers competitive and transparent pricing for Corporate Travels in Pune. We provide clear, upfront quotes with no hidden charges, allowing you to plan your corporate travel expenses without worry. Whether you need a short-term rental or long-term solutions, we offer flexible pricing options to suit your budget."
  },
  {
    "WhyChooseheading": "Clean, Comfortable, and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our fleet of buses is regularly cleaned and maintained to high standards. We ensure comfort and safety for your employees with clean interiors, ample seating, and air-conditioning for a pleasant ride. Whether you're heading to a business event or a team-building retreat, we provide a smooth and comfortable journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations Across Pune",
    "WhyChoosedescription": "We offer flexible and convenient pickup and drop-off points across Pune, including business hubs like Hinjewadi, Magarpatta, Kharadi, Aundh, and more. Whether it’s an office pickup or transportation to an event, we ensure timely and reliable service for your corporate needs."
  },
  {
    "WhyChooseheading": "Easy Booking and Dedicated Customer Support",
    "WhyChoosedescription": "Booking your corporate bus travel with Amruta Travels is quick and straightforward. You can book online, via phone, or visit our office for personalized assistance. Our customer support team is available to help you with route planning, special requests, and any last-minute changes, ensuring smooth operations for your corporate travel requirements."
  }
]













    }

const faqData = [
  {
    question: 'How can I book corporate travel services in Pune?',
    answer: 'Booking corporate travel services with Amruta Travels is easy. You can contact us via phone, email, or online booking. We’ll help you arrange transportation tailored to your company’s specific needs, whether it’s for staff transportation, corporate events, or business trips.',
  },
  {
    question: 'What types of buses do you offer for corporate travel in Pune?',
    answer: 'We offer a wide range of buses for corporate travel, including 32, 35, 40, 45, and 50-seater options. Our fleet includes both AC and non-AC buses, with luxury variants available for executive transport.',
  },
  {
    question: 'Do you provide buses for employee transportation in Pune?',
    answer: 'Yes, we specialize in providing reliable and punctual buses for employee transportation to and from offices in Pune. We offer flexible pickup and drop locations within the city and its surrounding areas.',
  },
  {
    question: 'Can you arrange transportation for corporate events in Pune?',
    answer: 'Absolutely! We provide buses for corporate events, conferences, seminars, and team outings. Whether it’s a small group or a large team, we ensure timely and safe transportation for your employees.',
  },
  {
    question: 'How much does corporate travel in Pune cost?',
    answer: 'The cost of corporate travel depends on factors like the number of buses, travel distance, trip duration, and other requirements. We offer customized quotes based on your company’s specific travel needs.',
  },
  {
    question: 'Are your buses equipped with amenities for corporate travel?',
    answer: 'Yes, our buses for corporate travel come with comfortable seating, air conditioning (for AC buses), Wi-Fi, and other amenities that ensure a productive and comfortable journey for your employees.',
  },
  {
    question: 'Do you offer round-the-clock corporate transport services in Pune?',
    answer: 'Yes, we offer flexible timing for corporate transport services in Pune. Whether your employees need to travel early in the morning or late at night, we can arrange buses that meet your schedule.',
  },
  {
    question: 'Can I request multiple pickup and drop-off locations for corporate travel in Pune?',
    answer: 'Yes, we offer flexible routing with multiple pickup and drop-off points within Pune and nearby areas. Just share your schedule, and we’ll plan the best route for your corporate transport.',
  },
  {
    question: 'Why choose Amruta Travels for corporate travel in Pune?',
    answer: 'Amruta Travels is known for its reliable and professional corporate transport services. We offer a fleet of well-maintained buses, trained drivers, and timely service to ensure a smooth and efficient travel experience for your employees.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rakesh Joshi',
    role: 'HR Head, IT Company, Pune',
    text: 'We hired a 50-seater bus from Amruta Travels for employee transport to a conference. The bus was clean, on time, and very comfortable. The service was excellent, and the driver was professional. We will definitely use them again for future corporate events.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Patil',
    role: 'Event Manager, Pune',
    text: 'Amruta Travels provided transportation for a corporate team-building event. The 45-seater bus was perfect for our group. Everything went smoothly, and our employees had a comfortable and safe journey. Highly recommend their service for corporate travel!',
    rating: 5,
  },
];



























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Travels in Pune",
  "image": "https://bushireinpune.com/assets/images/corporate-travel-in-pune.jpg",
  "description": "Amruta Travels offers reliable corporate travel solutions in Pune. Bus hire for corporate parties, team outings, team picnics, and transportation for office events. We provide buses ranging from 17 to 50 seaters, including AC and Non-AC options. Corporate travel services available for locations like Katraj, Hadapsar, Hinjewadi, and IT Park Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3999",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/corporate-travels-in-pune"
  }
};




    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Corporate Travels in Pune | Bus Hire for Corporate Events, Team Outings & More</title>
  <meta 
    name="description" 
    content="Book bus hire for corporate travels in Pune including team outings, picnics, and office events. 17-50 seater buses, AC/Non-AC options. Corporate travel services in Katraj, Hadapsar, Hinjewadi & IT Park Pune." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/48.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatetravelsinpune;